// Logo oficial Tecnomyl (PNG transparente, verde de marca). En tema oscuro pasa a blanco (clase tm-logo).
export default function Logo({ variant = "dark", size = "md" }) {
  const h = size === "lg" ? "h-12" : size === "sm" ? "h-7" : "h-[34px]";
  return (
    <div className="flex items-center select-none" data-testid="tecnomyl-logo">
      <img src="/logo-tecnomyl.png" alt="Tecnomyl S.A." className={`${h} w-auto object-contain tm-logo ${variant === "light" ? "brightness-0 invert" : ""}`} />
    </div>
  );
}
